import React, { Component } from "react";
import ReactDOM from "react-dom";
import {globales, colores, funciones  } from '../../../../global';
import Typography from '@material-ui/core/Typography';
import Cards from 'react-credit-cards-2';
import 'react-credit-cards-2/dist/es/styles-compiled.css';
import AuthService            from '../../../../AuthService';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton                           from '@material-ui/core/IconButton';
import DialogContent          from '@material-ui/core/DialogContent';
import BarraBotones   from '../../../../components/Barra_menu';
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress from '@material-ui/core/LinearProgress';
import { tr } from "date-fns/locale";
import { datePickerDefaultProps } from "@material-ui/pickers/constants/prop-types";
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import {withStyles} from '@material-ui/core/styles';
import logosCards from './logosCards';
import Request from 'superagent';
import transitions from "@material-ui/core/styles/transitions";
import { Checkmark }                        from 'react-checkmark';
import Backdrop                             from '@material-ui/core/Backdrop';
import { success } from "toastr";
import { config } from "react-spring";


var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
let tokenInfo = [];
let Auth = new AuthService();

const styles = theme => ({

paper: { 
  borderRadius: globales.border_dialog,
  minWidth: !movil ? '405px' : undefined, 
  maxWidth: !movil ? '405px' : undefined,
  minHeight: !movil ? '490px' : undefined, 
  maxHeight: !movil ? '490px' : undefined
  }, 
paperConfirm: { 
  borderRadius: globales.border_dialog,
  minWidth: '320px', 
  maxWidth: '320px', 
},

textField: {
    width: !movil ?'335px':'100%',
  },

textField2: {
    width: !movil ?'100px':'29%',
  },

textField3: {
    width: !movil ?'100px':'29%',
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
        display: "none",
      }

  },

closeButton: {
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500],
},

backdrop: {
  zIndex: 500000,
  color: '#fff', 
  flexDirection: 'column'
},

App_payment: {
    padding: '30px',
},

form: {
    margin: '30px auto 0',
    maxWidth: '400px',
  },
  

});

export default withStyles(styles) ( 
class App extends React.Component {
tablaRef = React.createRef();
vtRef    = React.createRef();
yearRef  = React.createRef();
monthRef  = React.createRef();
  constructor (props) {
    super(props);
    this.cerrarVentana = props.cerrarventana
      this.state = {
        gatewayReady: false,
        processing: false,
        showModal: false,
        orderid: "",
        cardNumber: "",
        //cardExpMonth: "",
        //cardExpYear: "",
        expiry:"",
        cvv: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        address1: "",
        city: "",
        state: "",
        postalCode: "",
        country: "HN",
        amount: 0,
        currency: "HNL",
        focus: '',
        open_dialog_pago:false,
        actualizarSaldo:false,
        message:'',
        success: false,
        transactionid:null,
        bloqueo:1,
        openBackDrop:true,
        iKey:"*",
        gatewayJSerror:0
 };

  }
/*
  async function postPayment(url, data) {
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  });
  return res.json();
}
 */

 postPayment= async (url, data)=> {
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  });
  return res.json();
  }

  sendFrontLog = (mensaje, codigo = 'FRONT_ERR', stack = null) => {
  try {
    const errorPayload = {
      message: mensaje,
      code: codigo,
      stack: stack,
      origin: 'Pago3DS_Front',
      cuenta_alumno: tokenInfo.user || 'ANONYMOUS',
      orderid: this.state.orderid,
      userAgent: navigator.userAgent
    };

    // Petición silenciosa (sin bloquear la interfaz del usuario)
    fetch(`${globales.ip}/pagolinea/logs`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Auth.getToken()
      },
      body: JSON.stringify(errorPayload)
    }).catch(() => {
      // Ignorar fallos de red en el envio de logs para evitar bucles infinitos
    });
  } catch (e) {
    // Fail-safe silencioso
  }
};

componentWillUnmount() {
  if (this.threeDSecureInterface) {
    try {
      this.threeDSecureInterface.unmount();
    } catch (e) {}
    this.threeDSecureInterface = null;
  }
}

  componentDidMount() {
  this._isMounted = true;
  tokenInfo = Auth.getProfile(); 
  

  const scriptId = "gateway-nmi-js";

  // 1. Si el SDK ya está cargado e inicializado en window, habilitamos la pasarela
  if (window.Gateway?.create) {
    if (this._isMounted) {
      this.setState({ gatewayReady: true});
    }
  } else {
    // 2. Si existía un tag <script> previo pero window.Gateway NO existe (quedó en estado corrupto/fallido), lo eliminamos
    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      existingScript.remove();
    }

    // 3. Crear e inyectar el nuevo script
    const script = document.createElement("script");
    script.id = scriptId;
    script.src = "https://secure.networkmerchants.com/js/v1/Gateway.js";
    script.async = true;

    script.onload = () => {
      if (window.Gateway?.create && this._isMounted) {
        this.setState({ gatewayReady: true });
      }
    };

    script.onerror = () => {
      this.sendFrontLog("Error al descargar script Gateway.js de NMI", "ERR_SDK_NMI_LOAD");
      // 🔑 CLAVE: Eliminar el script del DOM si falla la descarga para poder reintentar en el futuro
      const failedScript = document.getElementById(scriptId);
      if (failedScript) {
        failedScript.remove();
      }

      if (this._isMounted) {
        this.sendFrontLog("(GatewayJS) Error de conexión con la pasarela de pago. Por favor intente de nuevo.", "Gateway_isMounted")
        this.setState({
          //openBackDrop: false,
          success: 0,
          open_dialog_pago: true,
          amount:0,
          message: "(GatewayJS) Error de conexión con la pasarela de pago. Por favor intente de nuevo."
        },()=>{this.setState({gatewayJSerror:1}
       
        )});
      }
    };

    document.body.appendChild(script);
  }

  this.consultaPagoPendiente(2);
}

  handleInputChange = ({ target }) => {
    let { name, value } = target;
    if (name === 'cardNumber') {
          
         target.value = this.formatCreditCardNumber(value);  

      }
      
      else if ((name === 'expiry' || name=== 'expiry2') ) {
            
          name='expiry';

          value = this.formatExpirationDate(name,value);

// console.log("formatExpirationDate "+value)


      } else if (name === 'cvc') {
      
 
      } else if (name === 'name') {
        const { nombres, apellidos } = this.splitFullName(value);
       this.setState({firstName:nombres,lastName:apellidos });
       
      }

  
      this.setState({ [name]: value });
      
    };

    clearNumber(value = "") {
        return value.replace(/\D+/g, "");
      }

   
    
    formatCreditCardNumber(value) {
        if (!value) {
            return value;
          }
             
          const clearValue = this.clearNumber(value);
          let nextValue;
        
              nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
                4,
                8
              )} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 19)}`;
              
          
        
          return nextValue.trim();
      }

      formatExpirationDate(name,value) {
        /* if (!value) {
            return value;
          } */
          this.monthValue='';
          this.yearValue='';

        this.monthValue = this.monthRef.current.value.length===0?''+this.monthRef.current.value: (this.monthRef.current.value.length===1?0+this.monthRef.current.value:this.monthRef.current.value);
        this.yearValue  = this.yearRef.current.value.length ===0?'':(this.yearRef.current.value.length===1?'0'+this.yearRef.current.value:(this.yearRef.current.value.length===2?this.yearRef.current.value:this.yearRef.current.value.slice(-2)));    
       
          return this.monthValue+this.yearValue;
      }


  consultaPagoPendiente = (tipoRegistroPrevioPagos) =>{
    
    Request
           .post(`${globales.ip}/pagolinea/consulta_saldo_pendiente`) 
           .send({    
            CUENTA_ALUMNO:tokenInfo.user
           })       
           .retry(1)
           .timeout({ response: 60000, deadline: 60000, })
           .end((err, res) => {
                   
              if (err) {
           
                 if (err.toString().substr(0,16) === 'Error: Forbidden')
                 {                  
                   return;                     
                 }
           
                 (async function() {
                
                 })();//FIN FUNCION ASYNC
             
                 return;
              }
                 
              const datos  = JSON.parse(res.text);
                
              if (datos  !== undefined) {
  
                if(datos.MONTO<=0){                
                   this.setState({amount:0,open_dialog_pago:true,message:'No tiene saldo pendiente.',openBackDrop:false})
                 
                }else{ 
                  
                  this.setState({amount:datos.MONTO,orderid:datos.RESULT,iKey: window.crypto.randomUUID() ,openBackDrop:false},()=>{this.registroPrevioPagos(datos.RESULT,tipoRegistroPrevioPagos)})
               
                }

                  
                                                                                                                      
              }
                         
            
                               
            });
   
    }  
    
    
 registroPrevioPagos = (ID_FACTURA,TIPO) =>{
   
     Request
            .post(`${globales.ip}/pagolinea/registroPrevioPagos`) 
            .send({    
             CUENTA_ALUMNO :tokenInfo.user,
             ID_FACTURA    :ID_FACTURA,
             TIPO          :TIPO
            })       
            .retry(1)
            .timeout({ response: 60000, deadline: 60000, })
            .end((err, res) => {
                    
               if (err) {
            
                  if (err.toString().substr(0,16) === 'Error: Forbidden')
                  {                  
                    return;                     
                  }
            
                  (async function() {
                 
                  })();//FIN FUNCION ASYNC
              
                  return;
               }
                  
               const datos  = JSON.parse(res.text);
                     
               if (datos  !== undefined) {  
                 
              
                 if(datos.RESP==='OK'){
  
                   if (datos.RESULT>=1){
                      this.setState({open_dialog_pago:true,message:datos.MSG,bloqueo:1})
                   }
                   else{ 
                   this.setState({bloqueo:0})
                      
                 }
                  
                 }
                         
               }
                            
              else //SI NO HAY REGISTROS
              {
                
              } 
              
              
            
             });
    
     }   

  handleOk = async () => {
    
    /*
    // ----------- INICION - PARA PRUEBAS -------------------------------------------------
          try {
const { cvv, name, cardNumber, firstName, lastName, email, phone, address1, city, state, postalCode, country, amount, currency } = this.state;
            const e = {
              xid: null,
              cavv: 'AAUBBjWBkAAAAABkNAIQdQAAAAA=',
              eci: '05',
              cardHolderAuth: 'verified',
              threeDsVersion: '2.2.0',
              directoryServerId: 'd1be343c-cca3-4bf2-a05e-02f49df3d20a'
            }

            const options = {
          cardNumber: cardNumber.replace(/\s+/g, ""),
          cardExpMonth: this.formatoMes(this.monthRef.current.value),
          cardExpYear: this.formatoAno(this.yearRef.current.value),
          firstName,
          lastName,
          email,
          phone: phone.replace(/\D/g, ''), // Limpiar caracteres no numéricos
          address1,
          city,
          state,
          postalCode,
          country, // Asegúrate que sea formato ISO (ej: 'MX')
          amount: parseFloat(amount), // Forzar tipo numérico
          currency
        };

            const postData = { options, e, cvv: this.state.cvv, cuenta_alumno: tokenInfo.user, orderid: this.state.orderid,iKey:this.state.iKey };
            const data = await this.postPayment(`${globales.ip}/pagolinea/3dspayment`, postData);
            console.log(data) 
                    
            this.setState({
              open_dialog_pago: true,
              message: data.message,
              success: data.success,
              amount: data.success ? 0 : (data.amount ?? this.state.amount),
              transactionid: data.transactionid,
              openBackDrop: false,
               ...(data.iKey !== undefined && { iKey: data.iKey })
            });
          } catch (err) {
            this.setState({
              open_dialog_pago: true,
              message: "(3DSPAY) Error en la comunicación con el banco.",
              success: 0,
              openBackDrop: false,
              iKey: window.crypto.randomUUID()
            });
          }
  // ----------- FIN - PARA PRUEBAS -------------------------------------------------  
    */
    
   
  try {

    const { cvv, name, cardNumber, firstName, lastName, email, phone, address1, city, state, postalCode, country, amount, currency } = this.state;

    // 1. Validaciones básicas de campos
    if (cvv === "" || name === "" || cardNumber === "" || !this.monthRef.current.value || !this.yearRef.current.value) {
      funciones.showToast('w', 'Complete los datos solicitados');
      return;
    }

    if (this.threeDSecureInterface) {
    try {
      this.threeDSecureInterface.unmount();
    } catch (e) {
      console.warn("Intento de unmount previo ignorado:", e);
    }
    this.threeDSecureInterface = null;
  }

    // 3. Preparar estado (Activamos modal primero)
    this.setState({ processing: true, showModal: true }, async () => {
      try {
        if (!window.Gateway) {
           this.sendFrontLog("El SDK de Gateway no se ha cargado correctamente.", "Gateway");
          throw new Error("El SDK de Gateway no se ha cargado correctamente.");
        }
        
        const gateway = window.Gateway.create("checkout_public_J69fMpSeF596666pz6JNZApjBt8Van8q");
        const threeDS = gateway.get3DSecure();
        let browserJavaEnabled = "false";

        try {
          browserJavaEnabled = String(window.navigator.javaEnabled());
        } catch (e) {
          browserJavaEnabled = "false";
        }

        const options = {
          cardNumber: cardNumber.replace(/\s+/g, ""),
          cardExpMonth: this.formatoMes(this.monthRef.current.value),
          cardExpYear: this.formatoAno(this.yearRef.current.value),
          firstName,
          lastName,
          email,
          phone: phone.replace(/\D/g, ''), // Limpiar caracteres no numéricos
          address1,
          city,
          state,
          postalCode,
          country, 
          amount: parseFloat(amount), // Forzar tipo numérico
          currency,
          
               // NMI / 3DS
          browserJavaEnabled,
          browserJavascriptEnabled: String(true),
          browserLanguage:
            window.navigator.language ||
            window.navigator.userLanguage ||
            "es-HN",
          deviceChannel: "02" 
          

        };

        this.threeDSecureInterface = threeDS.createUI(options);

      
          this.threeDSecureInterface.on("complete", async (e) => {
          this.threeDSecureInterface.unmount();
          this.threeDSecureInterface = null;
          this.setState({ processing: false, showModal: false, openBackDrop: true });

          const validECI = [1, 2, 5, 6].includes(parseInt(e.eci));
          const validCAVV = e.cavv && e.cavv !== "";

          if (!validECI || !validCAVV) {
            this.sendFrontLog("La autenticación falló. Por favor, verifica tus datos o usa otra tarjeta.", "validECI/validCAVV");
            this.setState({
              openBackDrop: false,
              success: 0,
              open_dialog_pago: true,
              message: "La autenticación falló. Por favor, verifica tus datos o usa otra tarjeta."
            });
            return;
          }

          // Envío al Backend
          try {
            const postData = { options, e, cvv: this.state.cvv, cuenta_alumno: tokenInfo.user, orderid: this.state.orderid,iKey:this.state.iKey };
            const data = await this.postPayment(`${globales.ip}/pagolinea/3dspayment`, postData);
            
            this.setState({
              open_dialog_pago: true,
              message: data.message,
              success: data.success,
              amount: data.success ? 0 : data.amount,
              transactionid: data.transactionid,
              openBackDrop: false,
              iKey:data.iKey
            });
          } catch (err) {
            this.sendFrontLog(err.message, this.traducirError3DS(err), err?.stack || null);
            this.setState({
              open_dialog_pago: true,
              message: "(3DSPAY) Error en la comunicación con el banco.",
              success: 0,
              openBackDrop: false
            });
          }
        });

        this.threeDSecureInterface.on("error", (error) => {
          this.sendFrontLog(error.message, this.traducirError3DS(error), error?.stack || null);
          const mensaje = this.traducirError3DS(error);
          this.setState({ processing: false, showModal: false, open_dialog_pago: true, message: mensaje, success: 0 });
        });

        this.threeDSecureInterface.on("failure", (error) => {
          this.sendFrontLog(error.message, "(3DSF) Autenticación rechazada por el banco.");
          this.setState({ processing: false, showModal: false, open_dialog_pago: true, message: "(3DSF) Autenticación rechazada por el banco.", success: 0 });
        });

        // --- EL CAMBIO CLAVE ---
        // Esperamos un momento a que el modal termine de renderizarse en el DOM
        setTimeout(() => {
          try {
            this.threeDSecureInterface.start("#modal-body");
          } catch (mountError) {
            this.sendFrontLog(String(mountError), "(3DS-MOUNT) Error al iniciar el contenedor de pago.", mountError.stack);
            //console.error("Error al montar el iframe:", mountError);
            this.setState({ processing: false, showModal: false, open_dialog_pago: true, message: "(3DS-MOUNT) Error al iniciar el contenedor de pago." });
          }
        }, 500); // 500ms es un tiempo seguro para la animación del modal

      } catch (setupError) {
        this.sendFrontLog(String(setupError), "(3DS-INIT) Datos de tarjeta o configuración inválidos.", setupError.stack);
        //console.error("Error en configuración 3DS:", setupError);
        this.setState({ processing: false, showModal: false, open_dialog_pago: true, message: "(3DS-INIT) Datos de tarjeta o configuración inválidos.", success: 0 });
      }
    });

  } catch (err) {
    this.sendFrontLog(String(err), "*Error inesperado en el proceso.", err.stack);
    //console.error("Error crítico handleOk:", err);
    this.setState({ open_dialog_pago: true, message: "*Error inesperado en el proceso.", success: 0, openBackDrop: false });
  }
  
  
};

  closeModal = () => {
    // 🔑 Limpieza defensiva al cerrar
  if (this.threeDSecureInterface) {
    try {
      this.threeDSecureInterface.unmount();
    } catch (e) {
      console.warn("Error al desmontar en closeModal:", e);
    }
    this.threeDSecureInterface = null;
  }
  this.setState({ showModal: false, processing: false });
  };

  cerrarmodal_pago=()=>event=>{
  this.setState({open_dialog_pago: false},()=>{
     if (this.state.success  || this.state.amount<=0 || this.state.bloqueo || this.state.gatewayJSerror) {this.cerrarVentana()};
  }) 
  
}

  handleInputFocus = (e) => {

  let name =e.target.name

  if (name==='cvv'){name='cvc'}
    this.setState({ focus: name });
  
}

handlePrintClick = (TRANSACTIONID,PDF_DOWNLOAD=null)=>()=>{
const download = PDF_DOWNLOAD == null ? movil : PDF_DOWNLOAD;
  
  this.setState({ textbackdrop: "Procesando...",openBackDrop: true }, ()=>{
   
  new Request
  .get(`${globales.ip}/pagolinea/recibo/${Auth.getProfile().user.toString()}/${TRANSACTIONID}`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .retry(1)
  .timeout({ response: 15000, deadline: 30000, }) 
  .end((err, res) => {
          
     if (err) { 
  
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {         
          window.location.reload();
          return;             
        }
  
        this.setState({ openBackDrop: false }, ()=>{ 
         funciones.showToast('e', 'No hay conexión');
        });
    
        return;
     }
        
     const rows = JSON.parse(res.text);
  
     let monto = 0;
     rows.map((item)=>{
       monto += item.MONTO_TOTAL; 
       return item;
     });
     
     funciones.crearReciboPdf(this.state.orderid, 
                              funciones.getTime(rows[0].FECHA_PAGO), 
                              funciones.getTime(new Date(new Date()+" UTC").toISOString().slice(0, 10) + " 00:00:00", 0),
                              rows[0].REFERENCIA1,
                              rows[0].CUENTA_ALUMNO,
                              rows[0].NOMBRE_COMPLETO,
                              rows[0].DESCRIPCION_PLAN, 
                              rows,
                              rows[0].Simbolo + funciones.formatCurrency(monto),
                              rows[0].Simbolo + funciones.formatCurrency(monto), 
                              rows[0].Simbolo + "0.00", 
                              'Pago en línea',
                              download, 
                              ()=>{this.setState({ openBackDrop: false })});              
     
  });
  
  });
  
  }

  splitFullName = (fullName) => {
  if (!fullName || typeof fullName !== "string") {
    return { nombres: "", apellidos: "" };
  }
  const connectors = [
    "de",
    "del",
    "de la",
    "de los",
    "de las",
    "van",
    "von",
    "da",
    "dos",
    "das"
  ];

  // Normalizar texto
  const cleaned = fullName.trim().replace(/\s+/g, " ").toLowerCase();
  const words = cleaned.split(" ");

  // Función interna para capitalizar
  const capitalize = (text) =>
    text
      .split(" ")
      .map(
        (word) =>
          word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join(" ");

  if (words.length === 1) {
    return { nombres: capitalize(words[0]), apellidos: "" };
  }

  if (words.length === 2) {
    return {
      nombres: capitalize(words[0]),
      apellidos: capitalize(words[1])
    };
  }

  let apellidoParts = [];
  let i = words.length - 1;

  while (i >= 0) {
    apellidoParts.unshift(words[i]);

    const possibleConnector =
      words[i - 1] ? words[i - 1] + " " + words[i] : "";

    if (
      connectors.includes(words[i - 1]) ||
      connectors.includes(possibleConnector)
    ) {
      apellidoParts.unshift(words[i - 1]);
      i -= 2;
    } else {
      i--;
      if (apellidoParts.length >= 2) break;
    }
  }

  const nombresArray = words.slice(
    0,
    words.length - apellidoParts.length
  );

  return {
    nombres: capitalize(nombresArray.join(" ")),
    apellidos: capitalize(apellidoParts.join(" "))
  };
};

 formatoMes = (mes) => {
  const numero = Number(mes);

  if (isNaN(numero) || numero < 1 || numero > 12) {
    return "";
  }

  return String(numero).padStart(2, "0");
};

formatoAno = (year) => {
  if (year === null || year === undefined) return "";

  const value = String(year).trim();

  if (value.length === 2) {
    return "20" + value;
  }

  return value;
};

 traducirError3DS(error) {

  const mensaje = (error?.message || error || "").toLowerCase();

  if (mensaje.includes("acctnumber") || mensaje.includes("card number"))
    return "El número de tarjeta es inválido";

  if (mensaje.includes("expiration") || mensaje.includes("expiry"))
    return "La fecha de vencimiento de la tarjeta es incorrecta";

  if (mensaje.includes("cvv") || mensaje.includes("security code"))
    return "El código de seguridad (CVV) es incorrecto";

  if (mensaje.includes("insufficient"))
    return "Fondos insuficientes en la tarjeta";

  if (mensaje.includes("declined"))
    return "La transacción fue rechazada por el banco";

  if (mensaje.includes("not valid acctnumber"))
    return "El número de tarjeta no es válido";

  if (mensaje.includes("authentication"))
    return "Datos incorrectos.\n Por favor, verifica el número de tarjeta, la fecha de vencimiento y el CVV (código de seguridad), o intenta con otro método de pago.";

  return "(UNK) Error en el proceso de pago, por favor intentelo nuevamente. "+mensaje;
}



  render() {
    const { processing, showModal } = this.state;
    const { classes } = this.props;
    const boton_cerrar_modal_pago = 
[
  {icono: 'Close', nombre: 'Cerrar' ,onclick: this.cerrarmodal_pago(), display:'auto'} ,
  {icono: 'Print', nombre: 'Recibo' ,onclick: this.handlePrintClick(this.state.transactionid), display:this.state.transactionid==null?'none':'auto'},
  {icono: 'Save', nombre: 'Descargar' ,onclick: this.handlePrintClick(this.state.transactionid,true), display:this.state.transactionid==null?'none':movil?'none':'auto'},
]
const botones_pagar =
    [
     { disabled:this.state.openBackDrop || !!this.state.bloqueo , icono: 'Check', toolt: 'Pagar', nombre: 'Pagar',escritura:true , onclick: (this.state.bloqueo || this.state.amount<=0)?()=>{funciones.showToast('e', this.state.message)}:this.handleOk, display:'auto'}
    ]
    return (
       
       <div   style={{/*div 1*/ /* border:'solid',borderColor:'green', */ paddingTop:55,  marginLeft: !movil ? globales.tabla.marginleft : globales.tabla.marginleft_movil, marginRight: !movil ? globales.tabla.marginright : globales.tabla.marginright_movil }} className="disableTouchOptions">
        <h3>Formulario de Pago 3D Secure </h3>
        

         <div style={{ /*div 2*/display:'flex',justifyContent:'center'/* ,border:'solid',borderColor:'red' */}}>
                       
    <div style={{/*div 3*/ /* border:'solid',borderColor:'green', */display:movil?'table-cell':'flex',/* paddingTop:20 */}}>

    <div style={{/*div 4*//* border:'solid',borderColor:'yellow', */display:'flex',justifyContent: 'center',alignItems:'center'}}>
       <div style={{display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
        <Cards                                
                            cvc={this.state.cvv}
                            expiry={this.state.expiry}
                            focused={this.state.focus}
                            name={this.state.name||"NOMBRE EN LA TARJETA"/*this.state.firstName +' '+ this.state.lastName*/}
                            number={this.state.cardNumber}
                          
                            //placeholders={{name:'TU NOMBRE'}}
                          />
                          <Typography  component="div" style={{color:'#757575',fontSize:10}} >{this.state.iKey || "#"}</Typography>
        </div>                 
    </div>{/*fin div 4*/}

<div style={{ /*div 5*/ /* border:'solid',borderColor:'orange', */ display:'flex' ,justifyContent:'center',paddingLeft:!movil?50:0,paddingTop:!movil?0:10, }}>
  <form>
  <div> {/*fin div 6*/}
    <div style={{ /*fin div 7*/ display:'flex' ,justifyContent:'center'}}>
 <Typography  component="div" style={{color:'#757575',/*display:this.response_code==='100'?'none':'auto'*/}} >
                          <Box fontWeight="fontWeightBold" m={1}  fontSize="h6.fontSize">
                           Total a pagar:
                          </Box>
                          
                        </Typography>
           
                        <Typography  component="div" style={{color:'#757575',/*display:this.response_code==='100'?'none':'auto'*/}} >
                          <Box fontWeight="fontWeightBold" m={1}  fontSize="h6.fontSize">
                          L.  { (new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2}).format(this.state.amount)) }                          
                          </Box>
                        </Typography>
                        </div> {/*fin div 7*/}

                        <TextField           
                                        label="Número de tarjeta"                                                                                                                              
                                        variant="outlined"                                        
                                        name='cardNumber'                                                      
                                        placeholder='**** **** **** ****'                                   
                                        className={classes.textField}                                              
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        inputProps={{ maxLength: 19 }}
                                        onInput = {(e) =>{
                                        //   e.target.value = e.target.value.replace(/[^0-9]/g, '')
                                        }}
                                        onChange={this.handleInputChange}
                                        onFocus={this.handleInputFocus}
                                        
                        />
</div>{/*fin div 6 */}
 <div>
            <TextField 
                id="th"
                label="Nombre en la tarjeta"                                                                                      
                variant="outlined" 
                name='name'
                //placeholder=''
                className={classes.textField}        
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{ maxLength: 100 }}
                onChange={this.handleInputChange}
                onFocus={this.handleInputFocus}
              />
              
            </div>

<div style={{ /* div 7 border:'solid',borderColor:'black', */ display: 'flex' ,justifyContent: 'space-between' }}>

            <TextField              
                label="CVV"                                                                                     
                variant="outlined" 
                name='cvv'
                placeholder='123'
                className={classes.textField2}        
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{ maxLength: 4 }}
                onChange={this.handleInputChange}
                onFocus={this.handleInputFocus}
                defaultValue={this.state.number}
                type='password'
              /> 
            
               <TextField 
                label="Mes"                                                                                     
                variant="outlined" 
                name='expiry'
                type='number'
                placeholder='mm'
                className={classes.textField2}        
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{  inputProps: { min: 1, max: 12,ref: this.monthRef } }}          
                onInput={(e) => {
                                let value = e.target.value.replace(/\D/g, "");

                                // máximo 2 dígitos
                                value = value.slice(0, 2);

                                // si es mayor a 12, borrar
                                if (value !== "" && Number(value) > 12) {
                                  value = "";
                                }

                e.target.value = value;
                          }}
                onChange={this.handleInputChange}
                onFocus={this.handleInputFocus}
                onKeyUp={(e) => { if (e.target.value>12) {e.target.value=''; this.setState({expiry:''})  } }}
              /> 
            
            
               <TextField 
                label="Año"                                                                                     
                variant="outlined" 
                name='expiry2'
                type='number'
                placeholder='yy'
                className={classes.textField3}        
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{  inputProps: { min: 1, max: 12,ref: this.yearRef } }}          
                onInput={(e) => { e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,4) }}
                onChange={this.handleInputChange}
                onFocus={this.handleInputFocus}
              />  
            
              
            </div> {/*fin div 7*/}

          {/*  <button
          onClick={this.handleOk}
          style={{ marginTop: 15, padding: 10, width: "100%" }}
          disabled={processing}
        >
          {processing ? "Procesando..." : "Procesar Pago"}
        </button> */}  
         <BarraBotones align='center'  botones={botones_pagar}  />

            </form>

       {/*  <input name="firstName" placeholder="Nombre" onChange={this.handleChange}  onFocus={this.handleInputFocus}/>
        <input name="lastName" placeholder="Apellido" onChange={this.handleChange}  onFocus={this.handleInputFocus} />
        <input name="cardNumber" placeholder="Número de tarjeta" onChange={this.handleChange}  onFocus={this.handleInputFocus} />
        <input name="cardExpMonth" placeholder="MM" onChange={this.handleChange}  onFocus={this.handleInputFocus} />
        <input name="cardExpYear" placeholder="YYYY" onChange={this.handleChange}  onFocus={this.handleInputFocus} />
        <input name="cvv" placeholder="CVV" type="password" onChange={this.handleChange} onFocus={this.handleInputFocus} />
        <input name="email" placeholder="Email" onChange={this.handleChange} />
        <input name="phone" placeholder="Teléfono" onChange={this.handleChange} />
        <input name="address1" placeholder="Dirección" onChange={this.handleChange} />
        <input name="city" placeholder="Ciudad" onChange={this.handleChange} />
        <input name="state" placeholder="Estado" onChange={this.handleChange} />
        <input name="postalCode" placeholder="Código Postal" onChange={this.handleChange} /> */}

       
        {/* Modal 3DS */}
        {showModal &&
          ReactDOM.createPortal(
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999
              }}
              onClick={this.closeModal}
            >
              <div
                style={{
                  width: "400px",
                  height: "500px",
                  background: "#fff",
                  padding: 20,
                  borderRadius: 8,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center"
                }}
                onClick={(e) => e.stopPropagation()}
              >
                {/* Barra de procesamiento */}
                <Typography
                  hidden={!processing}
                  component="div"
                  style={{ color: "#757575", marginBottom: 10 }}
                >
                  Procesando, por favor espere...
                </Typography>

                {/* Contenedor donde cargará 3DS */}
                <div
                  id="modal-body"
                  style={{
                    width: "100%",
                    height: "100%",
                    flexGrow: 1
                  }}
                />
              </div>

              <button
                style={{
                  position: "absolute",
                  top: 20,
                  right: 20,
                  padding: "5px 10px",
                  zIndex: 10000
                }}
                onClick={this.closeModal}
              >
                X
              </button>
            </div>,
            document.body
          )}

          </div>{/*fin div 5*/}
</div> {/*fin div 3*/}

          <Dialog   open={this.state.open_dialog_pago} /*onClose={this.cerrarmodal_pago()}*/ fullWidth= {true} fullScreen= {movil?true:false} maxWidth={movil?'sm':'xs'} > 
                <DialogTitle><Typography component='span' variant='subtitle2'>Pago en línea</Typography>
                         <IconButton /* className={classes.closeButton} */ onClick={this.cerrarmodal_pago()} size="small">
                         {this.state.hiddenLP===true?<CloseIcon fontSize="small" />:''}
                         </IconButton>
                        </DialogTitle>
                <DialogContent style={{ padding: '20px' }}>
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }}>

    {/* Fila superior: checkmark + mensaje */}
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',    
      gap: '10px',
      marginBottom: '20px'
    }}>
       {
       
       this.state.success? (
        <Checkmark size="32px" color={colores.azul}  />
      ):''
      }


      <Typography style={{ textAlign: 'center' }}
        variant="h6"
        color={this.state.success ? 'primary' : 'error'}
      >
        {this.state.message}
      </Typography>
    </div>

    {/* Fila inferior: botones */}
    <BarraBotones align="center" botones={boton_cerrar_modal_pago} />

  </div>
</DialogContent>
            </Dialog>
            
            </div> {/*fin div 2*/}
              <div>{logosCards()}</div>
                 <Backdrop className={classes.backdrop} open={this.state.openBackDrop}>                                       
                 {/*  <CircularProgress color="inherit" /> */}
                  <span style={{ marginTop: '10px' }}>{'Por favor, espere un momento.'}</span>
                  </Backdrop>
      </div> /*fin div 1*/
    );
  }


})


//export default Pago3DS;
